import Vue from 'vue';
import Vuex from 'vuex';
import * as mutations from 'Store/mutations';
import * as actions from 'Store/actions';
import * as getters from 'Store/getters';
// import plugins from 'Store/plugins';
import debounce from 'lodash/debounce';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';
const store = new Vuex.Store({
    state: {
        breakpoints: [
            { id: 'mobile', width: 350 },
            { id: 'mobile-landscape', width: 480 },
            { id: 'tablet', width: 760 },
            { id: 'tablet-landscape', width: 980 },
            { id: 'desktop', width: 1180 },
            { id: 'grid', width: 1296 },
            { id: 'notebook', width: 1440 },
            { id: 'laptop', width: 1650 },
            { id: 'page', width: 1920 },
        ],
        windowHeight: window.innerHeight,
        windowWidth: window.innerWidth,
        activeBreakpoints: [],
        headerHeight: 0,
        activeFlyout: null,
        browser: false,
        lockPage: false,
        searchClient: null,
        searchBarVisible: false, // for search bar
        searchLoading: false,
        searchSuggestionsLoading: false,
        searchQuery: '',
        searchResults: {},
        searchSuggestions: {},
        searchResultsActive: false,
        searchSuggestionsActive: false,
        searchSuggestionsCurrentlyVisible: false,
        activeSearchCategoryTab: 'all',
    },
    mutations,
    actions,
    getters,
    // plugins,
    modules: {},
    strict: debug,
});

store.dispatch('setActiveBreakpoints');
store.dispatch('setHeaderHeight');
store.dispatch('setWindowHeight');

window.addEventListener(
    'resize',
    debounce(() => {
        store.commit('setWindowWidth', window.innerWidth);
        store.dispatch('setWindowHeight');
        store.dispatch('setActiveBreakpoints');
        store.dispatch('setHeaderHeight');
    }, 200),
);

export default store;
